import React from 'react';
import { Modal, Button } from 'antd';

const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  content,
  confirmLoading = false,
  confirmText = "Confirm",
  cancelText = "Cancel",
  zIndex = 1200,
}) => {
  return (
    <Modal
      title={title}
      open={isOpen}
      zIndex={zIndex}
      onCancel={confirmLoading ? undefined : onClose}
      closable={!confirmLoading}
      maskClosable={!confirmLoading}
      keyboard={!confirmLoading}
      footer={[
        <Button key="cancel" onClick={onClose} disabled={confirmLoading}>
          {cancelText}
        </Button>,
        <Button key="confirm" type="primary" onClick={onConfirm} danger loading={confirmLoading} disabled={confirmLoading}>
          {confirmText}
        </Button>,
      ]}
    >
      <p>{content}</p>
    </Modal>
  );
};

export default ConfirmModal; 